import { VersionSelectorState } from './reducer'
import { API } from '../../remote-api/models'
import selectorSelectors from '../redux/selector/selectors'

export const versionSelectorSelectors = <S>(getAll: (state: S) => VersionSelectorState) => {
  return {
    ...selectorSelectors<API, S>(getAll),
    getAll: (state: S) => (getAll(state) as VersionSelectorState)
  }
}
